import { render } from "./ListaContratacoesVigentesView.vue?vue&type=template&id=439a85e1&scoped=true"
import script from "./ListaContratacoesVigentesView.vue?vue&type=script&lang=js"
export * from "./ListaContratacoesVigentesView.vue?vue&type=script&lang=js"

import "./ListaContratacoesVigentesView.vue?vue&type=style&index=0&id=439a85e1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439a85e1"]])

export default __exports__